import { AppConfiguration } from './app.config'

export function getConfig(): AppConfiguration {
  const overrideClientId = sessionStorage.getItem('E2eClientIdPersona');
  const sgConnectConfig = window.sgmeConfiguration.sgconnect;

  if (overrideClientId && window.sgmeConfiguration.env === 'deve2e') {
    sgConnectConfig.client_id = overrideClientId;
  }

  return window.sgmeConfiguration;
}
